//ExpandGrid
site.expandGrid = {
	init: function () {
		if ($('.expand-grid').length === 0) return false;
		var $cells = $('.expand-grid > .item'),
			currentY = null,
			$body = $('body');

		//Click toggle
		$body.on('click', '.basic a.title', function(e) {
			e.preventDefault();
			console.log('click');

			var $thisCell = $(this).closest('.item'),
				$expand = $('.expand', $thisCell),
				delay = 0;

			var thisY = $expand.offset().top;

			//Some item is open
			if ($('.item.expanded').length > 0) {
				//Same row
				if (thisY == currentY) {
					delay = 0;
				}
				//Other row, must be closed first
				else {
					delay = 400;
				}
			}

			//Open new item
			if (!$thisCell.hasClass('expanded')) {
				var height = $expand[0].scrollHeight;

				if (delay === 0) {
					//Set max-height of this item to current item
					$('.expand','.expanded').css('max-height',height).css('opacity',0);
					$('.expanded').addClass('closing');
				}
				else {
					$('.expand','.expanded').css('max-height',0);
				}

				$thisCell.addClass('expanded');

				setTimeout(function() {
					$('.expand',$thisCell).css('max-height',height);
				},delay);


				setTimeout(function() {
					$cells.not($thisCell).removeClass('expanded').removeClass('closing');
					$('.expand', $cells.not($thisCell)).removeAttr('style');

					//Set the Y position of currently open item
					currentY = $expand.offset().top;
				},400);
			}

			//Close already open item
			else {
				$thisCell.removeClass('expanded');
				$expand.removeAttr('style');
			}
		});

		$('.expanded .expand .content').on('click', function(e) {
			e.stopPropagation();
		});
	}
};